import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import InputField from "../../components/Controls/InputField/InputField";
import { SelectComponent } from "../../components/Controls/Select/Select";
import * as actions from "../../store/labTests/actions";
import {getReferenceLabsListRequest} from "../../store/referenceLabs/actions";
import { injectIntl } from "react-intl";
import './style.scss';

const Filterform = ({ intl: { messages }, setSearchValues }) => {
  const dispatch = useDispatch();
  const payload = { page: 1, sort: "created_at,desc" };
  const { referenceLabsList } = useSelector((state) => state?.referenceLabs);
  const [referenceLabs, setReferenceLabs] = useState([]);
  const initialValues = {
    search: "",
    referenceLabId: 0, //ddl
  };
  const Filterchema = Yup.object().shape({
    search: Yup.string(),
    referenceLabId: Yup.object().nullable(),
  });
  const formik = useFormik({
    initialValues,
    validationSchema: Filterchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {},
  });

  useEffect(() => {
    dispatch(getReferenceLabsListRequest());
  }, [dispatch]);

  useEffect(() => {
    if (referenceLabsList && referenceLabsList.length > 0) {
      let list = [{
        id: 0,
        name: messages.labTests.all_labs,
      }];
      referenceLabsList.forEach((item) => {
        list.push({
          id: item.id,
          name: item.name.en,
        });
      });
      setReferenceLabs(list);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [referenceLabsList]);  
  
  const searchWithInput = (e, name) => {
    formik.setFieldValue(name, e.target.value)
    dispatch(
      actions?.getLabTestsRequest({
        ...payload,
        search: e.target.value,
        referenceLabId: formik.values.referenceLabId,
      })
    );
    setSearchValues({search: e.target.value, referenceLabId: formik.values.referenceLabId});
  };

  const searchWithSelect = (e, name) => {
    formik.setFieldValue(name, e.target.value);
    dispatch(
      actions?.getLabTestsRequest({
        ...payload,
        search: formik.values.search,
        referenceLabId: e.target.value,
      })
    );
    setSearchValues({search: formik.values.search, referenceLabId: e.target.value});
  };

  return (
    <div>
      <form className="form fv-plugins-bootstrap fv-plugins-framework">
        <div className="row">
          <div className="col-md-4">
            <InputField
              size="small"
              className={'bg-white phone_number'}
              label={messages.labTests.search}
              id="search"
              name="search"
              value={formik.values.search}
              changeHandler={formik.handleChange}
              error={formik.errors.search}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  searchWithInput(e, "search");
                }
              }}
            />
          </div>
          <div className="col-md-4 selection">
            {referenceLabs && referenceLabs.length > 0 && <SelectComponent
              className={'bg-white'}
              size="small"
              name="referenceLabId"
              list={referenceLabs}
              keyName="name"
              valueKeyName="id"
              value={formik.values.referenceLabId}
              handleChange={(e) => searchWithSelect(e, "referenceLabId")}
              error={formik.errors.requestSource}
            />}
          </div>
        </div>
      </form>
    </div>
  );
};

export default injectIntl(Filterform);
